function isWeakMap(value) {
    return value instanceof WeakMap;
}

export { isWeakMap };
